export const OPEN_EFFECTIVE_DATE_CONFIRM_MODAL = 'OPEN_EFFECTIVE_DATE_CONFIRM_MODAL';
export const CLOSE_EFFECTIVE_DATE_CONFIRM_MODAL = 'CLOSE_EFFECTIVE_DATE_CONFIRM_MODAL';

function openModal() {
  return {
    type: OPEN_EFFECTIVE_DATE_CONFIRM_MODAL
  };
}

function closeModal() {
  return {
    type: CLOSE_EFFECTIVE_DATE_CONFIRM_MODAL
  };
}

export function showEffectiveDateConfirmation() {
  return dispatch => dispatch(openModal());
}

export function hideEffectiveDateConfirmation() {
  return dispatch => dispatch(closeModal());
}
